export default "__VITE_ASSET__BGWo0BC4__"